<script>
  import LibEventBus from 'utils/libEventBus';
  import nextFrame from 'utils/nextFrame';

  export default {
    name: 'MTableStickableMixin',
    data () {
      return {
        columnStickyOffsets: {},
        stickyNeighbour: {}, // columns that has Intersection Observer for header
        stickyColumns: {}
      };
    },
    watch: {
      orderedIndexes () {
        nextFrame(() => {
          this.updateColumnStickyOffsets();
        });
      },
      tableParams: {
        handler () {
          this.updateColumnStickyOffsets();
        },
        deep: true
      }
    },
    mounted () {
      this.registerHeaderEventsListener('triggerSticky', this.handleTriggerSticky.bind(this));
      this.registerHeaderEventsListener('getBack', this.handleGetBack.bind(this));

      this.registerConfigureSecondLevelHeadersHook(this.secondLevelHeaderStickableHook.bind(this));

      this.registerBeforeHeaderRenderedHook(this.stickyBeforeHeaderRenderedHook.bind(this));
      this.registerBeforeCellRenderedHook(this.stickyBeforeCellRenderedHook.bind(this));
      this.updateColumnStickyOffsets();

      LibEventBus.$on('PAGE_RESIZE', this.updateColumnStickyOffsets);
      this.$on('hook:destroyed', () => {
        LibEventBus.$off('PAGE_RESIZE', this.updateColumnStickyOffsets);
      });
    },
    methods: {
      handleGetBack () {
        this.$emit('getBack');
      },

      handleTriggerSticky (column, state) {
        this.$set(this.stickyColumns, column, state);
      },

      /**
       * Update offsets map for sticky column
       * offset is parameter in css
       * {
       *   position: sticky;
       *   left: XXXpx; - this is offset
       * }
       */
      updateColumnStickyOffsets () {
        let currentOffset = 0;

        // reset all sticky neighbours
        Object.keys(this.stickyNeighbour).forEach(i => this.$set(this.stickyNeighbour, i, null));

        let prevSticky = '';
        let prevItemKey = null;
        this.orderedIndexes.forEach((itemKey) => {
          const item = this.tableParams[itemKey];

          if (item && item.width !== 'auto') {
            const columnParams = this.columnsMap[itemKey];
            if (!columnParams) {
              return;
            }

            if (prevItemKey) {
              const prevParams = this.columnsMap[prevItemKey];

              // add 1 px because border is not inside cell
              if (prevParams && prevParams.hasRightBorder) {
                currentOffset += 1;
              }
            }

            this.$set(this.columnStickyOffsets, itemKey, `${currentOffset}px`);

            if (columnParams.sticky) {
              prevSticky = itemKey;
              currentOffset += item.width;
            } else if (prevSticky) {
              this.$set(this.stickyNeighbour, itemKey, prevSticky);
              prevSticky = null;
            }
          } else {
            this.$set(this.columnStickyOffsets, itemKey, 0);
          }

          prevItemKey = itemKey;
        });

        // Turn off sticky state if only one column presents
        if (prevSticky) {
          this.handleTriggerSticky(prevSticky, false);
        }
      },

      secondLevelHeaderStickableHook (column, childColumns) {
        childColumns.forEach((childColumn, index) => {
          childColumn.sticky = column.sticky;
          if (index === 0) {
            column.stickyKey = childColumn.itemKey;
          }
          if (index === childColumns.length - 1) {
            column.stickyShadowActiveKey = childColumn.itemKey;
          }
        });
      },

      stickyBeforeHeaderRenderedHook (column) {
        column.stickyOffset = this.columnStickyOffsets;
        column.stickyNeighbourMap = this.stickyNeighbour;
        column.stickedColumns = this.stickyColumns;
        column.stickyKey = column.itemKey;
      },

      stickyBeforeCellRenderedHook (column) {
        column.stickyOffset = this.columnStickyOffsets;
        column.stickedColumns = this.stickyColumns;
      }
    }
  };
</script>
